let root = document.documentElement;

$(document).ready(function () {
  if (!$('.ie-11').length) {
    root.style.setProperty('--addedNumbForColWidth', 0 + 'px');
  }
  // т.к. для IE-11 подстановка переменной через скрипт почему-то не срабатывает, то по-умолчанию через :root задаём значение переменной необходимое для кооректного отображения столбцов в IE-11 (так работает), а скриптом переназначаем переменную для отображение в остальных браузерах
});
